import Tooltip from '../../control-components/ui-components/Tooltip'
import DeletePrivateMessage from './DeletePrivateMessage'

const PrivateMessageTooltip = (props) => (
  <div className='delete-private-message-tooltip'>
    <span className={'text--meta'}>
      <Tooltip trigger={<span className='icon--auto-width icon--ellipsis qa-private-message-delete-ellipsis' />} tooltipMessage={<DeletePrivateMessage {...props} />} />
    </span>
    {props.alertComponent}
  </div>
)
export default PrivateMessageTooltip
